"use strict";
// packages/types/src/queue.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueType = exports.JobStatus = void 0;
/**
 * Generic job status for queue jobs
 */
var JobStatus;
(function (JobStatus) {
    JobStatus["QUEUED"] = "queued";
    JobStatus["IN_PROGRESS"] = "in_progress";
    JobStatus["COMPLETED"] = "completed";
    JobStatus["FAILED"] = "failed";
})(JobStatus || (exports.JobStatus = JobStatus = {}));
/**
 * Queue job types
 */
var QueueType;
(function (QueueType) {
    QueueType["PAGE_GENERATION"] = "page_generation";
    QueueType["PLAN_IMPORT"] = "plan_import";
    QueueType["FLOWCHART_GENERATION"] = "flowchart_generation";
})(QueueType || (exports.QueueType = QueueType = {}));
